import React from "react";

export default function SectionTitle({ title, subtitle, right }) {
  return (
    <div className="ac-uc-sectiontitle">
      <div>
        <div className="ac-uc-sectiontitle-main">{title}</div>
        {subtitle ? (
          <div className="ac-uc-sectiontitle-sub">{subtitle}</div>
        ) : null}
      </div>

      {right ? <div className="shrink-0">{right}</div> : null}
    </div>
  );
}